import { checkIsAreaCategory } from './common';

export const getPriceTranslationKey = (
  categoryId: string,
  isLeased: boolean
) => {
  const isArea = checkIsAreaCategory(categoryId);

  switch (true) {
    case isArea && !isLeased:
      return 'new_search.price_per_area';

    default:
      return 'new_search.price';
  }
};
